// extracted by mini-css-extract-plugin
export default {"container":"RenderList_container__8Ut0W","emptyList":"RenderList_emptyList__B-3Af"};